import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

const CATALOG_BASE = 'api/inventory/v1/inventory-separation/catalog';

const catalogCompanySourceMapApi = {
    getCompanySourceOptions: async () => mmFetchWithResponse(`${CATALOG_BASE}/company-sources`),

    addExternalSkuCompanySource: async (externalSku, companySourceId) =>
        mmFetchWithResponse(`${CATALOG_BASE}/external-skus/${externalSku}/company-sources`, {
            method: 'POST',
            body: JSON.stringify({ companySourceId }),
        }),

    removeExternalSkuCompanySource: async (externalSku, companySourceId) =>
        mmFetchWithResponse(`${CATALOG_BASE}/external-skus/${externalSku}/company-sources/${companySourceId}`, {
            method: 'DELETE',
        }),

    addPackagingCompanySource: async (packagingId, companySourceId) =>
        mmFetchWithResponse(`${CATALOG_BASE}/packaging/${packagingId}/company-sources`, {
            method: 'POST',
            body: JSON.stringify({ companySourceId }),
        }),

    removePackagingCompanySource: async (packagingId, companySourceId) =>
        mmFetchWithResponse(`${CATALOG_BASE}/packaging/${packagingId}/company-sources/${companySourceId}`, {
            method: 'DELETE',
        }),
};

export { catalogCompanySourceMapApi };
